import styled from 'styled-components';

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  button[type='submit'] {
    margin-top: 8px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 20px;

    button[type='submit'] {
      margin-top: 4px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    gap: 24px;

    button[type='submit'] {
      margin-top: 8px;
    }
  }
`;

export const ZipWrapper = styled.div`
  width: 139px;
`;
